import * as React from "react";
import { useId, useIndex, useLayer } from "../../hooks";

type ChildFunction = (style: React.CSSProperties) => React.ReactElement<any>;

type MenuLayerProps = {
  children: React.ReactElement<any> | ChildFunction | null | false;
  element: { getBoundingClientRect: any } | null;
};

function MenuLayer({ children, element }: MenuLayerProps) {
  const id = useId();
  const zIndex = useIndex(id);

  const { updateLayer, removeLayer, parentElement } = useLayer(id);

  React.useEffect(() => {
    let top = 0;
    let left = 0;
    let width = 0;

    if (element) {
      const box = element.getBoundingClientRect();
      top = box.bottom;
      left = box.left;
      width = box.width;

      if (parentElement) {
        const box = parentElement.getBoundingClientRect();

        top = top - box.top;
        left = left - box.left;
      }
    }

    if (!children) {
      removeLayer();
      return;
    }

    const style: React.CSSProperties = {
      zIndex,
      top,
      left,
      position: "absolute",
      width
    };

    if (typeof children === "function") {
      updateLayer(children(style));
    } else {
      updateLayer(
        React.cloneElement(children as React.ReactElement<any>, {
          style: {
            ...(children.props.style || {}),
            ...style
          }
        })
      );
    }

    return removeLayer;
  });

  return null;
}

export default MenuLayer;
